import {SVG} from "@game/ui/images";
import cn from "classnames";

export const WinStars = () => (
    <div className={cn("popup__win-stars")}>
        <SVG.WinStars />
    </div>
);
